import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { apiUrl } from '../utils/apiBase';

function hasAdminToken() {
  try {
    return !!localStorage.getItem('admin_token');
  } catch (_e) {
    return false;
  }
}

export default function MaintenanceGate({ children }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [enabled, setEnabled] = React.useState(false);
  const [loaded, setLoaded] = React.useState(false);

  const fetchStatus = React.useCallback(async () => {
    try {
      const res = await fetch(apiUrl('/maintenance/status'), {
        headers: { Accept: 'application/json' },
      });
      const json = await res.json();
      const nextEnabled = !!json?.data?.enabled;
      setEnabled(nextEnabled);
      setLoaded(true);
    } catch (_e) {
      // If status can't be fetched, fail open (do not lock out users).
      setLoaded(true);
    }
  }, []);

  React.useEffect(() => {
    fetchStatus();
    const id = setInterval(fetchStatus, 60_000);
    return () => clearInterval(id);
  }, [fetchStatus]);

  React.useEffect(() => {
    if (!loaded) return;

    const path = location.pathname || '/';
    const isAdminPath = path.startsWith('/admin');
    const isMaintenancePath = path === '/maintenance';

    // Always allow admin routes so admins can log in during maintenance.
    if (isAdminPath) return;

    // When maintenance is enabled, redirect everyone except logged-in admins.
    if (enabled && !hasAdminToken() && !isMaintenancePath) {
      navigate('/maintenance', { replace: true });
      return;
    }

    // When maintenance is disabled, don't keep users stuck on the maintenance page.
    if (!enabled && isMaintenancePath) {
      navigate('/', { replace: true });
    }
  }, [enabled, loaded, location.pathname, navigate]);

  return children;
}


